module.exports = __webpack_public_path__ + "static/media/about-us.95dca74e.jpeg";